/* eslint-disable react/button-has-type */
/* eslint-disable react/jsx-filename-extension */
/* eslint-disable react/prop-types */
import React, { useState } from 'react';

import Fade from 'react-reveal/Fade';
import { Transition } from '@headlessui/react';

import Button from 'elements/Button';
import BrandIcon from 'parts/BrandIcon';

export default function Header(props) {
  const { location } = props;
  const [isCollapse, setIsCollapse] = useState(false);
  const [isServicesOpen, setIsServicesOpen] = useState(false);
  const path = location.pathname;

  return (
    <header className="header bg-white/95 backdrop-blur-sm shadow-sm sticky top-0 z-50">
      <Fade>
        <div className="container mx-auto flex justify-between items-center px-4 sm:px-6 lg:px-8 xl:px-12 py-3">
          <div className="flex-shrink-0">
            <BrandIcon />
          </div>

          <button className="block text-theme-blue lg:hidden focus:outline-none hover:text-theme-purple transition-colors duration-200" onClick={() => { setIsCollapse(!isCollapse); setIsServicesOpen(false); }} aria-label={isCollapse ? 'Close menu' : 'Open menu'}>
            <svg className="w-8 h-8" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path className={`${isCollapse ? 'hidden' : 'block'}`} strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16m-7 6h7" />
              <path className={`${!isCollapse ? 'hidden' : 'block'}`} strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>

          <ul className="hidden text-theme-blue tracking-wide items-center lg:flex flex-row mt-0 space-x-1 lg:space-x-2 xl:space-x-3">
            <li
              className="relative"
              onMouseEnter={() => setIsServicesOpen(true)}
              onMouseLeave={() => setIsServicesOpen(false)}
            >
              <Button
                className={`${path === '/service' || path === '/services' ? 'active-link' : ''} text-sm xl:text-base px-2 lg:px-3 xl:px-4 py-2 whitespace-nowrap no-underline rounded-lg transition-all duration-200 hover:bg-theme-purple/10 hover:text-theme-purple`}
                type="link"
                href="/service"
                location={location}
              >
                Services
              </Button>
              {isServicesOpen && (
                <div className="absolute top-full left-0 mt-1 w-80 bg-white shadow-xl border border-gray-200 rounded-lg py-2 z-50 max-h-96 overflow-y-auto">
                  <Button
                    type="link"
                    href="/solutions"
                    location={location}
                    className="block w-full text-left px-4 py-2.5 text-sm font-bold text-gray-800 hover:bg-gray-50 transition-colors duration-150 border-b border-gray-100"
                  >
                    SellonChat | eCommerce Platform & AI Assistant
                  </Button>
                  <Button
                    type="link"
                    href="/solutions"
                    location={location}
                    className="block w-full text-left px-4 py-2.5 text-sm font-bold text-gray-800 hover:bg-gray-50 transition-colors duration-150 border-b border-gray-100"
                  >
                    TalkTo Applications | Virtual Assistants For Businesses
                  </Button>
                  <Button
                    type="link"
                    href="/service"
                    location={location}
                    className="block w-full text-left px-4 py-2.5 text-sm font-bold text-gray-800 hover:bg-gray-50 transition-colors duration-150 border-b border-gray-100"
                  >
                    Business Optimization
                  </Button>
                  <Button
                    type="link"
                    href="/solutions"
                    location={location}
                    className="block w-full text-left px-4 py-2.5 text-sm font-bold text-gray-800 hover:bg-gray-50 transition-colors duration-150 border-b border-gray-100"
                  >
                    AI-Virtual Assistants
                  </Button>
                  <Button
                    type="link"
                    href="/service"
                    location={location}
                    className="block w-full text-left px-4 py-2.5 text-sm font-bold text-gray-800 hover:bg-gray-50 transition-colors duration-150 border-b border-gray-100"
                  >
                    Customer Support Solutions
                  </Button>
                  <Button
                    type="link"
                    href="/service/mobile-development"
                    location={location}
                    className="block w-full text-left px-4 py-2.5 text-sm text-gray-700 hover:bg-gray-50 transition-colors duration-150 border-b border-gray-100"
                  >
                    Mobile Development
                  </Button>
                  <Button
                    type="link"
                    href="/service/web-development"
                    location={location}
                    className="block w-full text-left px-4 py-2.5 text-sm text-gray-700 hover:bg-gray-50 transition-colors duration-150 border-b border-gray-100"
                  >
                    Web Development
                  </Button>
                  <Button
                    type="link"
                    href="/service/ui-ux-design"
                    location={location}
                    className="block w-full text-left px-4 py-2.5 text-sm text-gray-700 hover:bg-gray-50 transition-colors duration-150 border-b border-gray-100"
                  >
                    UI/UX Design
                  </Button>
                  <Button
                    type="link"
                    href="/service/product-engineering"
                    location={location}
                    className="block w-full text-left px-4 py-2.5 text-sm text-gray-700 hover:bg-gray-50 transition-colors duration-150 border-b border-gray-100"
                  >
                    Product Engineering
                  </Button>
                  <Button
                    type="link"
                    href="/service/cloud-managed-services"
                    location={location}
                    className="block w-full text-left px-4 py-2.5 text-sm text-gray-700 hover:bg-gray-50 transition-colors duration-150 border-b border-gray-100"
                  >
                    Cloud Managed Services
                  </Button>
                  <Button
                    type="link"
                    href="/service/technology-migration"
                    location={location}
                    className="block w-full text-left px-4 py-2.5 text-sm text-gray-700 hover:bg-gray-50 transition-colors duration-150 border-b border-gray-100"
                  >
                    Technology Migration
                  </Button>
                  <Button
                    type="link"
                    href="/service/internet-of-things"
                    location={location}
                    className="block w-full text-left px-4 py-2.5 text-sm text-gray-700 hover:bg-gray-50 transition-colors duration-150 border-b border-gray-100"
                  >
                    Internet Of Things
                  </Button>
                  <Button
                    type="link"
                    href="/service/deployment-support"
                    location={location}
                    className="block w-full text-left px-4 py-2.5 text-sm text-gray-700 hover:bg-gray-50 transition-colors duration-150 border-b border-gray-100"
                  >
                    Deployment & Support
                  </Button>
                  <Button
                    type="link"
                    href="/service/maintenance-scaling"
                    location={location}
                    className="block w-full text-left px-4 py-2.5 text-sm text-gray-700 hover:bg-gray-50 transition-colors duration-150 border-b border-gray-100"
                  >
                    Maintenance & Scaling
                  </Button>
                  <Button
                    type="link"
                    href="/service/data-engineering"
                    location={location}
                    className="block w-full text-left px-4 py-2.5 text-sm text-gray-700 hover:bg-gray-50 transition-colors duration-150 border-b border-gray-100"
                  >
                    Data Engineering
                  </Button>
                  <Button
                    type="link"
                    href="/service/architecture-design"
                    location={location}
                    className="block w-full text-left px-4 py-2.5 text-sm text-gray-700 hover:bg-gray-50 transition-colors duration-150"
                  >
                    Architecture Design
                  </Button>
                </div>
              )}
            </li>
            <li>
              <Button
                className={`${path === '/solutions' ? 'active-link' : ''} text-sm xl:text-base px-2 lg:px-3 xl:px-4 py-2 whitespace-nowrap no-underline rounded-lg transition-all duration-200 hover:bg-theme-purple/10 hover:text-theme-purple`}
                type="link"
                href="/solutions"
                location={location}
              >
                Solutions
              </Button>
            </li>
            <li>
              <Button
                className={`${path === '/technologies' ? 'active-link' : ''} text-sm xl:text-base px-2 lg:px-3 xl:px-4 py-2 whitespace-nowrap no-underline rounded-lg transition-all duration-200 hover:bg-theme-purple/10 hover:text-theme-purple`}
                type="link"
                href="/technologies"
                location={location}
              >
                Technologies
              </Button>
            </li>
            <li>
              <Button
                className={`${path === '/case-studies' || path === '/project' || path.startsWith('/project/') ? 'active-link' : ''} text-sm xl:text-base px-2 lg:px-3 xl:px-4 py-2 whitespace-nowrap no-underline rounded-lg transition-all duration-200 hover:bg-theme-purple/10 hover:text-theme-purple`}
                type="link"
                href="/case-studies"
                location={location}
              >
                Case Study
              </Button>
            </li>
            <li>
              <Button
                className={`${path === '/career' || path === '/careers' ? 'active-link' : ''} text-sm xl:text-base px-2 lg:px-3 xl:px-4 py-2 whitespace-nowrap no-underline rounded-lg transition-all duration-200 hover:bg-theme-purple/10 hover:text-theme-purple`}
                type="link"
                href="/career"
                location={location}
              >
                Careers
              </Button>
            </li>
            <li>
              <Button
                className={`${path === '/about' ? 'active-link' : ''} text-sm xl:text-base px-2 lg:px-3 xl:px-4 py-2 whitespace-nowrap no-underline rounded-lg transition-all duration-200 hover:bg-theme-purple/10 hover:text-theme-purple`}
                type="link"
                href="/about"
                location={location}
              >
                About
              </Button>
            </li>
            <li>
              <Button
                className={`${path === '/support' ? 'active-link' : ''} text-sm xl:text-base px-2 lg:px-3 xl:px-4 py-2 whitespace-nowrap no-underline rounded-lg transition-all duration-200 hover:bg-theme-purple/10 hover:text-theme-purple`}
                type="link"
                href="/support"
                location={location}
              >
                Support
              </Button>
            </li>
            <li>
              <Button
                className={`${path === '/blog' ? 'active-link' : ''} text-sm xl:text-base px-2 lg:px-3 xl:px-4 py-2 whitespace-nowrap no-underline rounded-lg transition-all duration-200 hover:bg-theme-purple/10 hover:text-theme-purple`}
                type="link"
                href="/blog"
                location={location}
              >
                Blog
              </Button>
            </li>
            <li>
              <Button
                className={`${path === '/contact' ? 'active-link' : ''} text-sm xl:text-base px-2 lg:px-3 xl:px-4 py-2 whitespace-nowrap no-underline rounded-lg transition-all duration-200 hover:bg-theme-purple/10 hover:text-theme-purple`}
                type="link"
                href="/contact"
                location={location}
              >
                Contact us
              </Button>
            </li>
            <li className="ml-3 lg:ml-4 xl:ml-6">
              <Button
                className="text-sm xl:text-base whitespace-nowrap px-4 lg:px-5 xl:px-6 py-2.5 bg-gradient-to-r from-theme-purple to-dark-theme-purple text-white rounded-lg shadow-md hover:shadow-lg transform transition-all duration-200 hover:scale-105"
                type="link"
                href="/discuss-project"
                location={location}
              >
                Discuss Project
              </Button>
            </li>
          </ul>
        </div>
      </Fade>

      <Transition
        show={isCollapse}
        enter="transition-opacity duration-400"
        enterFrom="opacity-0"
        enterTo="opacity-100"
        leave="transition-opacity duration-400"
        leaveFrom="opacity-100"
        leaveTo="opacity-0"
      >
        <Fade>
          <ul className="z-50 flex flex-col text-theme-blue tracking-widest my-6 absolute bg-white w-full border-b-2 border-gray-300 lg:hidden">
            <li className="py-2 bg-white">
              <button
                type="button"
                className={`${path === '/service' || path === '/services' ? 'active-link' : ''} px-10 no-underline hover:underline text-left w-full`}
                onClick={() => setIsServicesOpen(!isServicesOpen)}
              >
                Services
                <svg className={`inline-block ml-2 w-4 h-4 transition-transform duration-200 ${isServicesOpen ? 'rotate-180' : ''}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                </svg>
              </button>
              {isServicesOpen && (
                <ul className="bg-gray-50 border-t border-gray-200">
                  <li>
                    <Button
                      type="link"
                      href="/solutions"
                      location={location}
                      onClick={() => { setIsCollapse(false); setIsServicesOpen(false); }}
                      className="block w-full text-left px-10 py-2.5 text-sm font-bold text-gray-800 hover:bg-gray-100"
                    >
                      SellonChat | eCommerce Platform & AI Assistant
                    </Button>
                  </li>
                  <li>
                    <Button
                      type="link"
                      href="/solutions"
                      location={location}
                      onClick={() => { setIsCollapse(false); setIsServicesOpen(false); }}
                      className="block w-full text-left px-10 py-2.5 text-sm font-bold text-gray-800 hover:bg-gray-100"
                    >
                      TalkTo Applications | Virtual Assistants For Businesses
                    </Button>
                  </li>
                  <li>
                    <Button
                      type="link"
                      href="/service"
                      location={location}
                      onClick={() => { setIsCollapse(false); setIsServicesOpen(false); }}
                      className="block w-full text-left px-10 py-2.5 text-sm font-bold text-gray-800 hover:bg-gray-100"
                    >
                      Business Optimization
                    </Button>
                  </li>
                  <li>
                    <Button
                      type="link"
                      href="/solutions"
                      location={location}
                      onClick={() => { setIsCollapse(false); setIsServicesOpen(false); }}
                      className="block w-full text-left px-10 py-2.5 text-sm font-bold text-gray-800 hover:bg-gray-100"
                    >
                      AI-Virtual Assistants
                    </Button>
                  </li>
                  <li>
                    <Button
                      type="link"
                      href="/service"
                      location={location}
                      onClick={() => { setIsCollapse(false); setIsServicesOpen(false); }}
                      className="block w-full text-left px-10 py-2.5 text-sm font-bold text-gray-800 hover:bg-gray-100"
                    >
                      Customer Support Solutions
                    </Button>
                  </li>
                  <li>
                    <Button
                      type="link"
                      href="/service/mobile-development"
                      location={location}
                      onClick={() => { setIsCollapse(false); setIsServicesOpen(false); }}
                      className="block w-full text-left px-10 py-2.5 text-sm text-gray-700 hover:bg-gray-100"
                    >
                      Mobile Development
                    </Button>
                  </li>
                  <li>
                    <Button
                      type="link"
                      href="/service/web-development"
                      location={location}
                      onClick={() => { setIsCollapse(false); setIsServicesOpen(false); }}
                      className="block w-full text-left px-10 py-2.5 text-sm text-gray-700 hover:bg-gray-100"
                    >
                      Web Development
                    </Button>
                  </li>
                  <li>
                    <Button
                      type="link"
                      href="/service/ui-ux-design"
                      location={location}
                      onClick={() => { setIsCollapse(false); setIsServicesOpen(false); }}
                      className="block w-full text-left px-10 py-2.5 text-sm text-gray-700 hover:bg-gray-100"
                    >
                      UI/UX Design
                    </Button>
                  </li>
                  <li>
                    <Button
                      type="link"
                      href="/service/product-engineering"
                      location={location}
                      onClick={() => { setIsCollapse(false); setIsServicesOpen(false); }}
                      className="block w-full text-left px-10 py-2.5 text-sm text-gray-700 hover:bg-gray-100"
                    >
                      Product Engineering
                    </Button>
                  </li>
                  <li>
                    <Button
                      type="link"
                      href="/service/cloud-managed-services"
                      location={location}
                      onClick={() => { setIsCollapse(false); setIsServicesOpen(false); }}
                      className="block w-full text-left px-10 py-2.5 text-sm text-gray-700 hover:bg-gray-100"
                    >
                      Cloud Managed Services
                    </Button>
                  </li>
                  <li>
                    <Button
                      type="link"
                      href="/service/technology-migration"
                      location={location}
                      onClick={() => { setIsCollapse(false); setIsServicesOpen(false); }}
                      className="block w-full text-left px-10 py-2.5 text-sm text-gray-700 hover:bg-gray-100"
                    >
                      Technology Migration
                    </Button>
                  </li>
                  <li>
                    <Button
                      type="link"
                      href="/service/internet-of-things"
                      location={location}
                      onClick={() => { setIsCollapse(false); setIsServicesOpen(false); }}
                      className="block w-full text-left px-10 py-2.5 text-sm text-gray-700 hover:bg-gray-100"
                    >
                      Internet Of Things
                    </Button>
                  </li>
                  <li>
                    <Button
                      type="link"
                      href="/service/deployment-support"
                      location={location}
                      onClick={() => { setIsCollapse(false); setIsServicesOpen(false); }}
                      className="block w-full text-left px-10 py-2.5 text-sm text-gray-700 hover:bg-gray-100"
                    >
                      Deployment & Support
                    </Button>
                  </li>
                  <li>
                    <Button
                      type="link"
                      href="/service/maintenance-scaling"
                      location={location}
                      onClick={() => { setIsCollapse(false); setIsServicesOpen(false); }}
                      className="block w-full text-left px-10 py-2.5 text-sm text-gray-700 hover:bg-gray-100"
                    >
                      Maintenance & Scaling
                    </Button>
                  </li>
                  <li>
                    <Button
                      type="link"
                      href="/service/data-engineering"
                      location={location}
                      onClick={() => { setIsCollapse(false); setIsServicesOpen(false); }}
                      className="block w-full text-left px-10 py-2.5 text-sm text-gray-700 hover:bg-gray-100"
                    >
                      Data Engineering
                    </Button>
                  </li>
                  <li>
                    <Button
                      type="link"
                      href="/service/architecture-design"
                      location={location}
                      onClick={() => { setIsCollapse(false); setIsServicesOpen(false); }}
                      className="block w-full text-left px-10 py-2.5 text-sm text-gray-700 hover:bg-gray-100"
                    >
                      Architecture Design
                    </Button>
                  </li>
                </ul>
              )}
            </li>
            <li className="py-2 bg-white">
              <Button
                className={`${path === '/solutions' ? 'active-link' : ''} px-10 no-underline hover:underline`}
                type="link"
                href="/solutions"
                location={location}
              >
                Solutions
              </Button>
            </li>
            <li className="py-2 bg-white">
              <Button
                className={`${path === '/technologies' ? 'active-link' : ''} px-10 no-underline hover:underline`}
                type="link"
                href="/technologies"
                location={location}
              >
                Technologies
              </Button>
            </li>
            <li className="py-2 bg-white">
              <Button
                className={`${path === '/case-studies' || path === '/project' || path.startsWith('/project/') ? 'active-link' : ''} px-10 no-underline hover:underline`}
                type="link"
                href="/case-studies"
                location={location}
              >
                Case Study
              </Button>
            </li>
            <li className="py-2 bg-white">
              <Button
                className={`${path === '/career' || path === '/careers' ? 'active-link' : ''} px-10 no-underline hover:underline`}
                type="link"
                href="/career"
                location={location}
              >
                Careers
              </Button>
            </li>
            <li className="py-2 bg-white">
              <Button
                className={`${path === '/about' ? 'active-link' : ''} px-10 no-underline hover:underline`}
                type="link"
                href="/about"
                location={location}
              >
                About
              </Button>
            </li>
            <li className="py-2 bg-white">
              <Button
                className={`${path === '/support' ? 'active-link' : ''} px-10 no-underline hover:underline`}
                type="link"
                href="/support"
                location={location}
              >
                Support
              </Button>
            </li>
            <li className="py-2 bg-white">
              <Button
                className={`${path === '/blog' ? 'active-link' : ''} px-10 no-underline hover:underline`}
                type="link"
                href="/blog"
                location={location}
              >
                Blog
              </Button>
            </li>
            <li className="py-2 bg-white">
              <Button
                className={`${path === '/contact' ? 'active-link' : ''} px-10 no-underline hover:underline`}
                type="link"
                href="/contact"
                location={location}
              >
                Contact us
              </Button>
            </li>
            <li className="mx-auto my-9 bg-white">
              <Button
                className="mx-auto px-5 py-2 bg-theme-purple text-white rounded-full border-2 border-theme-purple hover:bg-dark-theme-purple border-purple-800 transition duration-200"
                type="link"
                href="/discuss-project"
                location={location}
              >
                Discuss Project
              </Button>
            </li>
          </ul>
        </Fade>
      </Transition>
    </header>
  );
}
